import rights from './rights'

export default {
    fundingProgramId: 'Förderprogramm {id}',

    number: 'Nummer',
    name: 'Name',
    shortName: 'Kurzname',
    description: 'Beschreibung',
    parentFundingProgram: 'Übergeordnetes Förderprogramm',
    noParentFundingProgram: 'Kein übergeordnetes Förderprogramm',
    isActive: 'Aktiv',
    manualHours: 'Lehrgangsstunden manuell erfassen',

    selectParentFundingProgramWarning: 'Warnung: Wenn du ein übergeordnetes Förderprogramm auswählst, werden alle diesem Programm zugeordneten Programme losgelöst und Verknüpfungen aufgehoben. Dies kann nicht rückgängig gemacht werden. Anzahl der untergeordneten Programme: {count}',

    forms: 'Formulare',

    slideOver: {
        description: 'Wähle ein Formular aus, um einen neuen Vorgang zu erstellen.',
        descriptionExisting: 'Wähle ein Formular aus, um es dem Vorgang hinzuzufügen.',
        search: 'Suche',
        searchPlaceholder: 'Suche nach Förderprogrammen'
    },

    savedSuccessfully: 'Förderprogramm wurde erfolgreich gespeichert.',
    saveError: 'Das Förderprogramm konnte nicht gespeichert werden.',
    deleteFundingProgram: 'Förderprogramm löschen',
    deleteFundingProgramText: 'Möchtest du dieses Förderprogramm wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteFundingProgramSuccess: 'Förderprogramm wurde erfolgreich gelöscht.',
    deleteFundingProgramError: 'Das Förderprogramm konnte nicht gelöscht werden.',

    reportsExplanation: 'Hier kann festgelegt werden, welche Auswertungen für das Förderprogramm verfügbar sind.',

    processFieldsExplanation: 'Hier kann für das Förderprogramm festgelegt werden, welche Vorgangsfelder für die ' +
        'Vorgänge verwendet werden sollen, und in welcher Reihenfolge diese zusammenhängen. Eine 0 blendet das entsprechende ' +
        'Feld in der Bearbeitung aus. Eine Zahl >= 1 legt fest, in welcher Reihenfolge das Feld bei einem Tab fokussiert wird. ' +
        'Um die Standardreihenfolge zu verwenden, gebe einfach bei allen Feldern eine 1 ein.',

    table: {
        title: 'Förderprogramme',
        name: 'Name',
        parentFundingProgram: 'Übergeordnetes Förderprogramm',
        parent_funding_program_name: 'Übergeordnet',
        short_name: 'Kurzname',
        description: 'Beschreibung',
        is_active: 'Aktiv',
        created_at: 'Erstellt am'
    },

    menu: {
        fundingProgramBaseData: 'Daten',
        fundingProgramRights: 'Rechte',
        fundingProgramReports: 'Auswertungen',
        fundingProgramProcessFields: 'Vorgangsfelder'
    },

    rights
}